/* eslint-disable no-unused-expressions */
import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import "../../App.css";
import { useEffect, useState } from "react";
import { Dropdown, Menu, Modal, Space, Spin } from "antd";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getUserQuoteById } from "../../lib/quotes";
import { generatePDF } from "../shared/pdf/generatePDF";
import { toast } from "react-toastify";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
// import useNextOrderNumber from "../quoteadmin/updateOrderNo";
import { FormatDate } from "../../lib/dateFormat";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { useMyContext } from "../../context/MyContext";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import AskForModel from "../shared/askForQuestion";
import DashboardLayout from "../layout";
import { Tooltip } from "react-tooltip";
import { FaDownload, FaRegEye } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import { generateTrackingNumber } from "../../lib/helper/trackingNumber";
import { api } from "../../config/api";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Loader from "../shared/loader/loader";
import { Loader2 } from "lucide-react";


function Newqoutes() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const quoteId = searchParams.get("quote");
  const obj = {
    active: true,
    content: "My Quotes",
  };
  const { user, notifications, setNotifications } = useMyContext();
  // console.log(user?.uid)

  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(
    quoteId ? true : false
  );
  const [selectedId, setSelectedId] = useState(quoteId ? quoteId : "");
  const [filteredData, setFilteredData] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [pdfCache, setPdfCache] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState({})

  //helper function to manage multiple action loading states for each row item
  const setLoading = (id, action, value) => {
    setLoadingStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [action]: value
      }
    }))
  }


  // In Newqoutes.js
  const { data, isLoading, isError, refetch } = useQuery(
    ["userQuotes", user?.uid],
    async () => {
      const res = await getUserQuoteById(user?.uid);
      return res;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 0, // This will make sure the data is always fetched
    }
  );
  // console.log(data)
  useEffect(() => {
    if (data) {
      const searchParams = new URLSearchParams(location.search);
      const quoteId = searchParams.get('quote');
      const quoteNumber = searchParams.get('quoteNumber');

      if (quoteId) {
        const quote = data.find(item => item.id === quoteId);
        if (quote) {
          setSelectedId(quoteId);
          setIsCommentModalOpen(true);
        }
      } else if (quoteNumber) {
        const quote = data.find(item => item.quoteNumber === quoteNumber);
        if (quote) {
          setSelectedId(quote.id);
          setIsCommentModalOpen(true);
        }
      } else {
        setIsCommentModalOpen(false);
        setSelectedId('');
      }

      // Sort and filter data
      const sortedData = data.sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate));
      setFilteredData(sortedData.filter(item => item.status === "pending" && item.sendStatus === true));
      setShowLoader(false);
    }
  }, [location.search, data]);

  const handleCommentClick = async (id, quoteNumber) => {
    showCommentModal(id, quoteNumber);

    try {
      await api.put(`/notifications/quotes/${user?.uid}`, {
        role: user?.role,
        quoteNumber: quoteNumber,
      });

      // Update the notifications state
      setNotifications(prevNotifications =>
        prevNotifications.map(notification =>
          notification.quoteNumber === quoteNumber
            ? { ...notification, read: true }
            : notification
        )
      );

      queryClient.invalidateQueries(["notifications"]);
    } catch (error) {
      console.error("Error updating notification:", error);
    }
  };

  const handleClickOutside = (event) => {
    // if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //   setShow(false);
    //   setSelected(null);
    // }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const showCommentModal = (id, quoteNumber) => {
    setSelectedId(id);
    setIsCommentModalOpen(true);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("quote", id);
    if (quoteNumber) {
      searchParams.set("quoteNumber", quoteNumber);
    } else {
      searchParams.delete("quoteNumber");
    }
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };
  const handleCommentModalClose = () => {
    setIsCommentModalOpen(false);
    setSelectedId("");
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("quote");
    searchParams.delete("quoteNumber");
    navigate(`${location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`, { replace: true });
  };
  const handleGeneratePdf = async (quote) => {
    setLoading(quote.id, "download", true);
    try {
      // const userDocRef = doc(db, 'quotes', id);
      // const userDocSnap = await getDoc(userDocRef);

      // if (userDocSnap.exists()) {
      //   const data = userDocSnap.data();
      //   setFormData(data);
      // } else {
      //   toast.error('Quote data not found');
      // }

      if (quote) {
        const blob = await generatePDF(quote);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${quote.quoteNumber}.pdf`;
        link.click();
      }


    } catch (error) {
      toast.error("Error fetching Quote data:", error);

    } finally {
      setLoading(quote.id, "download", false);
    }
  };

  // const { nextOrderNo } = useNextOrderNumber();
  // console.log(nextOrderNo)

  // Define the updateStatus function
  const updateStatus = async (id, quoteNumber) => {
    setLoading(id, "accept", true);
    try {
      // Assigning the order number and updating the quote happen in one idempotent backend transaction.
      const allocRes = await api.post("/firestore/order-number/assign", {
        quoteId: id,
        status: "in progress",
        trackingNumber: generateTrackingNumber(),
        shipmentCreatedDate: new Date().toISOString(),
      });
      const finalOrderNumber = allocRes?.data?.orderNumber;
      if (!finalOrderNumber) {
        throw new Error("Failed to assign order number");
      }

      // Send notification
      await api.post("/notifications", {
        title: "Quote Accepted",
        message: `Quote ${quoteNumber} has been accepted by ${user.name}`,
        linkText: "View Quote",
        link: `/quoteadmin?quote=${id}`,
        role: "admin",
        quoteNumber: quoteNumber,
        type: "quote-accepted",
      });


      toast.success("Quote Status updated successfully!");
      queryClient.invalidateQueries(["userQuotes", user?.uid]);
      refetch(); // Refresh data instead of page reload
    } catch (error) {

      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    } finally {
      setLoading(id, 'accept', false)
    }
  };

  const declineStatus = async (id, quoteNumber) => {
    setLoading(id, 'decline', true)
    try {
      const userDocRef = doc(db, "quotes", id);
      // const orderNumberRef = await getDoc(userDocRef);

      await updateDoc(userDocRef, { status: "decline" });

      // Send notification to admin
      await api.post("/notifications", {
        title: "Quote Cancelled",
        message: `Quote ${quoteNumber} has been cancelled by ${user.name}`,
        linkText: "View Quote",
        link: `/quoteadmin?quote=${id}`,
        role: "admin",
        quoteNumber: quoteNumber,
        type: "quote-cancelled",
      });

      toast.success("Quotes Status updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    } finally {
      setLoading(id, 'decline', false)
    }
  };

  // useEffect(() => {
  //   setFilteredData(data && data.filter(item => item.status === "pending" && item.sendStatus === true));

  // }, [data]);
  useEffect(() => {
    if (data) {
      const sortedData = data.sort(
        (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
      );
      setFilteredData(
        sortedData.filter(
          (item) => item.status === "pending" && item.sendStatus === true
        )
      );
    }
  }, [data]);

  // const [pdfUrl, setPdfUrl] = useState(null);

  // In Newqoutes.js
  const handleViewPdf = async (quote) => {
    setLoading(quote.id, 'view', true)
    try {
      let pdfUrl;
      if (!pdfCache[quote.id]) {
        // Refetch the latest data before generating PDF
        await refetch();

        // Get the latest version of the quote
        const updatedQuote = data.find(q => q.id === quote.id);

        const pdfBlob = await generatePDF(updatedQuote);
        pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfCache(prevCache => ({ ...prevCache, [quote.id]: pdfUrl }));
      } else {
        pdfUrl = pdfCache[quote.id];
      }

      setPdfUrl(pdfUrl); // This will trigger the PDF modal to open
    } catch (error) {
      toast.error("Error generating PDF:", error);
    } finally {
      setLoading(quote.id, 'view', false)
    }
  };
  useEffect(() => {
    return () => {
      Object.values(pdfCache).forEach(URL.revokeObjectURL);
    };
  }, [pdfCache]);

  // console.log(getAlpha2Code('pakistan'))
  return (
    <>
      {pdfUrl && (
        <Modal
          title="Quotation"
          visible={true}
          onCancel={() => setPdfUrl(null)}
          footer={null}
          width="60%"
        >
          <iframe
            src={`${pdfUrl}#toolbar=0`}
            title="Quotation PDF"
            style={{ width: "100%", height: "70vh", border: 0 }}
          ></iframe>
        </Modal>
      )}
      <Modal
        title={
          <div className="flex flex-col">
            <span>Comments</span>
            <span className="text-xs opacity-60">
              Quote No: {data?.find((q) => q?.id === selectedId)?.quoteNumber}
            </span>
          </div>
        }
        open={isCommentModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCommentModalClose}
        width={"70%"}
        styles={{ body: { padding: 0 } }}
      >
        <AskForModel id={selectedId} />
      </Modal>
      <Modal
        title="Comment"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCommentModalClose}
      >
        <textarea className="w-full h-[100px] border border-gray-300 p-2 rounded-md focus:outline-none" />

        <button className="mt-4 w-[130px] text-white rounded-md h-[40px] bg-blue-700">
          Send
        </button>
      </Modal>
      <DashboardLayout>
        {/* <div className="hidden h-full border-r sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          <Header title="New Quotes" />

          {showLoader ? (
            <Loader />
          ) : (

            <div className="h-full p-4 bg-cus-gray">
              <div className="flex items-center justify-between bg-white rounded-md">
                <div className=" w-full inline">
                  <table className="w-full text-sm text-start ">
                    <thead className="font-normal">
                      <tr className="border-b-2">
                        <th className="p-2">Quote</th>
                        <th className="p-3">Date</th>
                        <th className="p-1">Route</th>

                        <th className="p-1">Quote Request Status</th>

                        <th className="p-1">Action</th>
                      </tr>
                    </thead>
                    {filteredData &&
                      filteredData.map((quote, index) => (
                        <tbody key={index}>
                          <tr className="border-b-2 py-3 text-center">
                            <td className="p-1">{quote.quoteNumber}</td>
                            <td className="p-1">
                              {FormatDate(quote.creationDate)}
                            </td>
                            <td className="p-1">
                              {getAlpha2Code(quote.loadCountry)} -{" "}
                              {getAlpha2Code(quote.unloadCountry)}
                            </td>

                            <td className="p-1 py-2 flex justify-center items-center gap-3">
                              <button
                                data-tooltip-id="view"
                                onClick={() => handleViewPdf(quote)}
                                className="py-1 px-3 rounded-md bg-[#A9A9A9] text-white disabled:bg-opacity-50"
                                disabled={loadingStates[quote.id]?.view}
                              >
                                {loadingStates[quote.id]?.view ? (
                                  <Loader2 className="animate-spin" />
                                ) : (
                                  <FaRegEye className="text-2xl" />
                                )}
                              </button>

                              <button
                                data-tooltip-id="Accept"
                                onClick={() =>
                                  updateStatus(quote.id, quote.quoteNumber)
                                }
                                className="py-1 px-3 rounded-md  bg-[#7CE13E] text-white disabled:bg-opacity-50"
                                disabled={loadingStates[quote.id]?.accept}
                              >
                                {/* Accept */}
                                {loadingStates[quote.id]?.accept ? (
                                  <Loader2 className="animate-spin" />
                                ) : (
                                  <FaCheckCircle className="text-2xl" />
                                )}
                              </button>

                              <button
                                data-tooltip-id="download"
                                className="py-1 px-3 rounded-md  bg-[#3861DC] text-white disabled:bg-opacity-50"
                                onClick={() => handleGeneratePdf(quote)}
                                disabled={loadingStates[quote.id]?.download}
                              >
                                {/* Download */}
                                {loadingStates[quote.id]?.download ? (
                                  <Loader2 className="animate-spin" />
                                ) : (
                                  <FaDownload className="text-2xl" />

                                )}
                              </button>

                              <button
                                data-tooltip-id="cancel"
                                onClick={() =>
                                  declineStatus(quote.id, quote.quoteNumber)
                                }
                                className="py-1 px-3 rounded-md  bg-[#EE3025] text-white disabled:bg-opacity-50"
                                disabled={loadingStates[quote.id]?.decline}
                              >
                                {/* Decline */}
                                {loadingStates[quote.id]?.decline ? (
                                  <Loader2 className="animate-spin" />
                                ) : (
                                  <MdOutlineCancel className="text-2xl" />
                                )}
                              </button>
                            </td>

                            <td className="p-1">
                              <Dropdown
                                overlay={
                                  <Menu>
                                    <Menu.Item
                                      key="askQuestion"
                                      onClick={() => handleCommentClick(quote.id, quote.quoteNumber)}
                                    >
                                      Ask A Question
                                    </Menu.Item>
                                  </Menu>
                                }
                                visible={openDropdownIndex === index}
                                trigger={["click"]}
                                onVisibleChange={(visible) => {
                                  setOpenDropdownIndex(visible ? index : null);
                                }}
                              >
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenDropdownIndex(index);
                                  }}
                                >
                                  <Space>
                                    <button className="border relative p-1 rounded-md border-[#053F92] relative">
                                      <PiDotsThreeVerticalBold size={20} />
                                      {notifications?.find(
                                        (e) =>
                                          e?.quoteNumber === quote?.quoteNumber &&
                                          e?.read === false
                                      ) ? (
                                        <div className="w-2 h-2 absolute -top-[2px] right-0 bg-red-600 rounded-full"></div>
                                      ) : null}
                                    </button>
                                  </Space>
                                </a>
                              </Dropdown>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    <Tooltip id="view" place="top" content="View Quote in PDF" />

                    <Tooltip id="Accept" place="top" content="Accept Quote " />
                    <Tooltip
                      id="download"
                      place="top"
                      content="Download Quote in PDF"
                    />
                    <Tooltip id="cancel" place="top" content="Cancel Quote" />
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
}

export default Newqoutes;
